namespace GeniuzPOS.Purchase {
    export class PoPurOrderDtAppColumns {
        static columnsKey = 'Purchase.PoPurOrderDtApp';
    }
}
